import _ from 'lodash';

/**
 * @type {Object}
 */
export const USER_ROLES = {
  ADMINISTRATOR: 'administrator',
  OFFICE: 'office',
  REPRESENTATIVE: 'representative',
  SERVICE_PARTNER: 'service_partner',
  SUPERVISOR: 'supervisor',
};

/**
 * @type {Array}
 */
export const USER_ROLE_OPTIONS = [
  { value: 'representative', label: 'Representative' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'administrator', label: 'Administrator' },
  { value: 'office', label: 'Office' },
  { value: 'service_partner', label: 'Service Partner' },
];

export const USER_ROLE_DESCRIPTIONS = {
  administrator:
    'Access to view and edit all data, including ability to add and remove users, clients and properties.',
  office: 'Read-only access to view all data, cannot edit or delete users, clients or properties.',
  representative:
    'Access to view and edit data only for their assigned tasks, cannot add or delete users, clients or properties or view full client detail.',
  service_partner:
    'Invite companies or vendors you work with to view and edit data only for their assigned tasks. Service Partners can also manage their own employees or teams.',
  supervisor:
    'Access to view and edit data for their department, cannot add or delete users, clients or properties or view full client detail.',
};

/**
 * @type {Array.<String>}
 */
export const userRolesArray = _.values(USER_ROLES);

/**
 * @param {Array.<String>|String} excludedRoles
 * @return {Array.<String>}
 */
export const filterRoles = (excludedRoles = []) =>
  _.filter(userRolesArray, role => {
    if (_.isString(excludedRoles)) {
      return role !== excludedRoles;
    } else if (_.isArray(excludedRoles)) {
      return _.indexOf(excludedRoles, role) === -1;
    }

    return true;
  });

/**
 * @param {String} userRole
 * @param {Object} opt
 * @return {Boolean}
 */
export const includesUserRole = (userRole = USER_ROLES.OFFICE, opt = {}) => {
  const options = {
    excludedRoles: [],
    ...opt,
  };

  return _.includes(filterRoles(options.excludedRoles), userRole);
};

export const roleHasDepartments = userRole =>
  _.includes(['supervisor', 'representative', 'service_partner'], userRole);

export const isOfficeUser = userRole => userRole === USER_ROLES.OFFICE;
